export const BSC_GRADE = [
  { label: '', value: null },
  { label: 'Good', value: 4 },
  { label: 'Satisfactory', value: 3 },
  { label: 'Fair', value: 2 },
  { label: 'Unsatisfactory', value: 1 },
  { label: 'Ungraded', value: 0 }
]

export function getBscGradeInText (targetGrade: number) {
  return BSC_GRADE.find(grade => grade.value === targetGrade)?.label
}
